query GET_RESERVATIONS ($endDate: Date, $startDate: Date, $facilityId: UUID, $status: String, $signupCode: String) {
  reservations (
    endDate: $endDate,
    startDate: $startDate,
    facilityId: $facilityId,
    status: $status,
    signupCode: $signupCode
  ) {
    count
    items {
      id
      checkinDatetime
      checkoutDatetime
      status
      signupCode
      topups {
        amount
      }
      parker {
        id
        user {
          firstName
          lastName
        }
        email
        phone
      }
      lot {
        name
      }
      vehicle {
        licenseNumber
      }
      review {
        feedback
        rating
        isRecommended
        status
        rewardCredited
      }
    }
  }
}
